import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=e04f686a&"
import script from "./Team.vue?vue&type=script&lang=ts&"
export * from "./Team.vue?vue&type=script&lang=ts&"
import style0 from "./Team.vue?vue&type=style&index=0&id=e04f686a&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports